import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Info } from 'lucide-react';
import { Button } from './ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table';
import { pricing, siteConfig } from '../data/mock';
import { trackWhatsAppClick } from '../lib/analytics';

const PricingSection = () => {
  return (
    <section id="precios" className="py-20 bg-page">
      <div className="container mx-auto px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          {/* Section header */}
          <motion.div
            className="text-center mb-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="heading-1 mb-4">Precios orientativos</h2>
            <p className="body-medium text-secondary">
              Tarifas base para que tengas una referencia inicial.
            </p>
          </motion.div>

          {/* Pricing table */}
          <motion.div
            className="bg-white rounded-2xl shadow-lg overflow-hidden"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <Table>
              <TableHeader>
                <TableRow className="bg-accent-grey-200">
                  <TableHead className="font-semibold text-primary">Servicio</TableHead>
                  <TableHead className="text-right font-semibold text-primary">Precio</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {pricing.map((item, index) => (
                  <TableRow key={index} className="border-b border-border last:border-0">
                    <TableCell className="font-medium text-primary">{item.service}</TableCell>
                    <TableCell className="text-right">
                      <span className="font-semibold text-amber-600">{item.price}</span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </motion.div>

          {/* Note */}
          <motion.div
            className="mt-6 p-4 rounded-xl flex items-start gap-3"
            style={{ backgroundColor: '#E4EDF8' }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <Info className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: '#4A6FA5' }} />
            <p className="text-sm" style={{ color: '#333333' }}>
              El precio final depende de las fechas, la zona y las necesidades específicas de tu perro. Contáctame para un presupuesto personalizado.
            </p>
          </motion.div>

          {/* CTA */}
          <motion.div
            className="text-center mt-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <a
              href={siteConfig.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackWhatsAppClick('pricing')}
              data-testid="whatsapp-btn-pricing"
            >
              <Button className="btn-primary rounded-full px-8 py-6 text-base gap-2">
                <MessageCircle className="w-5 h-5" />
                Pedir presupuesto
              </Button>
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
